(function() {
    'use strict';

    angular.module('customerVault')
        .controller('ErrorsController', ErrorsController);

    ErrorsController.$inject = ['$state', 'breadcrumbsService'];

    function ErrorsController($state, breadcrumbsService) {
        var vm = this;

        var error = null;
        var home = true;
        switch ($state.current.name) {
            case 'forbidden':
                error = 'Access Denied';
                break;
            case 'account':
            case 'passwordreset':
            case 'register':
                error = "Redirecting...";
                home = false;
                break;
            default:

        }

        vm.showHome = home;
        vm.steps = breadcrumbsService.get('errors', {error: error});
        vm.title = error;
    }
})();
